<template>
  <v-dialog v-model="visible" max-width="500px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="form.nombre" label="Nombre" outlined dense hide-details clearable></v-text-field>

              <small v-for="error in errores.nombre" :key="error" class="d-block text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="form.descripcion"
                label="Descripción"
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small v-for="error in errores.descripcion" :key="error" class="d-block text-danger">{{ error }}</small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text :disabled="enviando" @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="enviando"
          :loading="enviando"
          @click.prevent="() => validar(registrar, editar)">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import ConceptoService from '../services/concepto.service';
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';

export default {
  name: 'ModalFormularioSedeUniversidad',
  mixins: [modalFormMixin, apiConsumerMixin],
  watch: {
    'form.nombre': function () {
      this.errores.nombre = [];
    },
    'form.descripcion': function () {
      this.errores.descripcion = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        nombre: null,
        descripcion: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        nombre: data.nombre,
        descripcion: data.descripcion,
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
    },
    guardar(accion) {
      this.guardarDatosMixin(
        ConceptoService.create,
        ConceptoService.update,
        accion,
        this.form,
        this.nombreRecurso,
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>